import { useState } from 'react';

interface ImageWithFallbackProps {
  src: string | undefined;
  alt: string;
  className?: string;
  fallbackSrc?: string;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
  width?: number;
  height?: number;
}

export const ImageWithFallback = ({
  src,
  alt,
  className = '',
  fallbackSrc = '/placeholder.svg',
  loading = "lazy",
  fetchPriority = "auto",
  width,
  height
}: ImageWithFallbackProps) => {
  const [imgSrc, setImgSrc] = useState(src || fallbackSrc);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (!hasError) {
      setHasError(true);
      setImgSrc(fallbackSrc);
    }
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={handleError}
      loading={loading}
      decoding={loading === "eager" ? "sync" : "async"}
      // @ts-expect-error React doesn't have fetchpriority in its types yet
      fetchpriority={fetchPriority}
      width={width}
      height={height}
    />
  );
};
